import api from "../utils/api";

export const createDepartment = async (department_name) => {
  try {
    const response = await api.post("/department", department_name);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getDepartment = async (department_id) => {
  try {
    const response = await api.get(`/department/${department_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAllDepartments = async () => {
  try {
    const response = await api.get("/department");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const updateDepartment = async (department_id, updated_department_name) => {
  try {
    const response = await api.put(`/department/${department_id}`, updated_department_name);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteDepartment = async (department_id) => {
  try {
    const response = await api.delete(`/department/${department_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
